import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavbarMO.scss';

function NavbarMO({ isOpen, setIsOpen, isLoggedIn, onToggleLogin, onOpenBrochureModal }) {
  const location = useLocation();
  const closeMenu = () => setIsOpen(false);
  if (!isOpen) return null;

  return <nav className="mobileNav lms-mobile-nav" id="lms-mobile-menu" aria-label="전체 메뉴">
    <div className="mobileNav-header">메뉴</div>
    <div className="menu open">
      <Link className="menuItem" to="/" onClick={closeMenu} aria-current={['/', '/homeApp', '/main'].includes(location.pathname) ? 'page' : undefined}>HOME</Link>
      <Link className="menuItem" to="/board" onClick={closeMenu} aria-current={location.pathname === '/board' ? 'page' : undefined}>공지사항</Link>
      <button className="menuItem" type="button" onClick={onOpenBrochureModal}>브로셔</button>
      <Link className="menuItem" to="/storeBook" onClick={closeMenu} aria-current={location.pathname === '/storeBook' ? 'page' : undefined}>교재(문제)구매</Link>
      {isLoggedIn && <Link className="menuItem" to="/directMessageApp" onClick={closeMenu} aria-current={location.pathname === '/directMessageApp' ? 'page' : undefined}>문자전송</Link>}
      <button className="menuItem menuItem-session" type="button" onClick={onToggleLogin}>{isLoggedIn ? '로그아웃' : '로그인'}</button>
    </div>
  </nav>;
}

export default NavbarMO;
